import request from '@/utils/request'

//查询所有题目
export function SelectQuestion(params) {
    return request({
        url: '/api/ExamQuestion/Load',
        method: 'get',
        params
    })
}

//添加题目
export function AddQuestion(data) {
    return request({
        url: '/api/ExamQuestion/Add',
        method: 'post',
        data
    })
}

//查询题目详情
export function SelectDetails(params) {
    return request({
        url: '/api/ExamQuestion/Get',
        method: 'get',
        params
    })
}

//删除题目
export function DeleteQuestion(data) {
    return request({
        url: '/api/ExamQuestion/Delete',
        method: 'post',
        data
    })
}

//修改题目
export function UpdateQuestion(data) {
    return request({
        url: '/api/ExamQuestion/Update',
        method: 'post',
        data
    })
}

//上传图片
export function uploadimg(data) {
    return request({
        url: '/images/Upload/Pic',
        method: 'post',
        data
    })
}

//导入考题
export function ImportQuestion(url, data) {
    return request({
        url: url,
        method: 'post',
        data: data
    })
}
//审核
export function Examine(data) {
    return request({
        url: '/api/ExamQuestion/Pass',
        method: 'post',
        data
    })
}

//查重
export function getRepeatList(data) {
    return request({
        url: '/api/ExamQuestion/RepeatList',
        method: 'post',
        data
    })
}

//获取树形
export function getTree(params) {
    return request({
        url: '/api/ExamQuestionType/GetTree',
        method: 'get',
        params
    })
}

export function GetTreeDetial(params) {
    return request({
        url: '/api/ExamQuestionType/GetTreeDetial',
        method: 'get',
        params
    })
}


//添加树形
export function addTree(data) {
    return request({
        url: '/api/ExamQuestionType/Add',
        method: 'post',
        data
    })
}
//删除树形
export function delTree(params) {
    return request({
        url: '/api/ExamQuestionType/Delete',
        method: 'get',
        params
    })
}
//修改树形
export function updateTree(data) {
    return request({
        url: '/api/ExamQuestionType/Update',
        method: 'post',
        data
    })
}
//获取详细
export function getDetail(params) {
    return request({
        url: '/api/ExamQuestionType/Get',
        method: 'get',
        params
    })
}